import React, { useEffect, memo } from 'react';
import { usePrevious } from '@atlassian/jira-platform-react-hooks-use-previous/src/common/utils/index.tsx';
import {
	setPreviousRouterState,
	type RouterState,
} from '@atlassian/jira-platform-router-utils/src/common/utils/index.tsx';

import { RouterSubscriber } from '@atlassian/react-resource-router';

const PreviousRouterStateUpdate = ({ routerState }: { routerState: RouterState }) => {
	const previousRouterState = usePrevious(routerState);

	useEffect(() => {
		setPreviousRouterState(previousRouterState ?? null);
	}, [previousRouterState]);

	return null;
};

const PreviousRouterStateListener = memo(() => (
	<RouterSubscriber>
		{(routerState) => <PreviousRouterStateUpdate routerState={routerState} />}
	</RouterSubscriber>
));

PreviousRouterStateListener.displayName = 'PreviousRouterStateListener';

export { PreviousRouterStateListener, PreviousRouterStateUpdate };
